import { render, staticRenderFns } from "./CafeteriaViewProducibleProducts.vue?vue&type=template&id=67a98f56"
import script from "./CafeteriaViewProducibleProducts.vue?vue&type=script&lang=js"
export * from "./CafeteriaViewProducibleProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports